__turbopack_context__.v({
  "className": "cinzel_aabae544-module__7LHDNq__className",
  "variable": "cinzel_aabae544-module__7LHDNq__variable",
});
